export default {
  state: {
    onProgress: false,
  },
  mutations: {
    setProgress: (state: any, progress: boolean) => {
      state.onProgress = progress;
    },
  },
};
